import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Suppress Vercel's deprecated zustand warnings (from their internal instrumentation, not our code)
const originalWarn = console.warn;
console.warn = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('[DEPRECATED] Default export is deprecated')) return;
  originalWarn.apply(console, args);
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);